<template>
	<div>
		<div class="assessment-questions mt-5">
			<table class="table">
				<tr>
					<th></th>
					<th>Strongly Dislike</th>
					<th>Dislike</th>
					<th>Unsure</th>
					<th>Like</th>
					<th>Strongly Like</th>
					<th></th>
				</tr>
				<tr is="faces-question" :current-page="currentPage" :code="q.code" :number="q.weight" :answer="q.user_answer" :question="q.label" v-for="q in questions" @interface="q.answer = $event"></tr>
			</table>
		</div>
		<!--<hr>-->
	</div>
</template>
<script>
	export default {
		name: 'FacesAssessment',
		componentName: 'faces-assessment',
		props: [
			'questions',
            'currentPage'
		],
		data(){
			return{
				questionsList: this.questions,
			}
		},
		methods: {
			isAnswered: function(){
				return !this.questionsList.some(function(element){
					return element.answer === 0;
				});
			},
			goPrev: function(){
				
			},
			goNext: function(){
				if( this.isAnswered() ){
					console.log(this.questionsList);
				}
			}
		},
		mounted: function () {

		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/interests/FacesAssessment.vue